import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Choice,
  ChoiceIcon,
  ChoicePanel,
  ClockIcon,
  Container,
  FoldPanel,
  PackageIcon,
  Specimens,
  UsersIcon,
} from '@src/components';

const exchangeOptions = [
  { value: 'meet', tone: 'accent', Icon: UsersIcon },
  { value: 'send', tone: 'support', Icon: PackageIcon },
  { value: 'later', tone: 'warning', Icon: ClockIcon },
] as const;

export function ChoiceSection() {
  const { t } = useTranslation();
  const [exchange, setExchange] = useState('meet');
  const [letter, setLetter] = useState('yes');

  return (
    <FoldPanel
      id="choices"
      title="Creation choices"
      hint="Game creation uses plain ChoicePanels inside the creation card. The creation shell supplies the heading and navigation."
      example={`<ChoicePanel plain>
  <Choice
    name="letter"
    value="yes"
    title={t('newBox.letter.yes.title')}
    description={t('newBox.letter.yes.body')}
    checked={letter === 'yes'}
    onCheckedChange={() => setLetter('yes')}
  />
</ChoicePanel>`}
    >
      <Specimens
        label="Exchange method"
        note="The three options used in game creation, with their actual icons and copy."
      >
        <Container width="measure">
          <ChoicePanel plain>
            {exchangeOptions.map(({ value, tone, Icon }) => (
              <Choice
                key={value}
                name="kit-exchange"
                value={value}
                icon={
                  <ChoiceIcon tone={tone}>
                    <Icon />
                  </ChoiceIcon>
                }
                title={t(`newBox.exchange.${value}.title`)}
                description={t(`newBox.exchange.${value}.body`)}
                checked={exchange === value}
                onCheckedChange={() => setExchange(value)}
              />
            ))}
          </ChoicePanel>
        </Container>
      </Specimens>
      <Specimens label="Letter to Santa" note="The text-only choice layout used in game creation.">
        <Container width="measure">
          <ChoicePanel plain>
            {(['yes', 'no'] as const).map((value) => (
              <Choice
                key={value}
                name="kit-letter"
                value={value}
                title={t(`newBox.letter.${value}.title`)}
                description={t(`newBox.letter.${value}.body`)}
                checked={letter === value}
                onCheckedChange={() => setLetter(value)}
              />
            ))}
          </ChoicePanel>
        </Container>
      </Specimens>
    </FoldPanel>
  );
}
